<script setup>
import { ref, onBeforeMount } from "vue";
const props = defineProps({
  closeModal: Function,
  rolesOptions: Array,
  sitesOptions: Array,
});
import useValidation from "@/utils/helpers/validations";
import { useCompanyStore } from "@/stores/company";
import { useUiStore } from "@/stores/ui";
import { useUsersStore } from "@/stores/users";

const uiStore = useUiStore();
const usersStore = useUsersStore();
const { checkEmailValidation } = useValidation();
const emit = defineEmits(["refresh", "refreshSitesArr"]);
const companyId = useCompanyStore().companyId;
const user = ref(JSON.parse(localStorage.getItem("userDetails")));

let id = ref(null);
let first_name = ref(null);
let last_name = ref(null);
let email = ref(null);
let phone = ref("");
let country_code = ref("");
let intial_country_code = ref("");
let role = ref(null);
let sites = ref([]);
let resources = ref([]);
let isValidEmail = ref(true);
let isValidPhone = ref(true);
let isSubmitted = ref(false);
let isEmailLoading = ref(false);
let isPhoneLoading = ref(false);
let showSitesSecttion = ref(true);
// let update = ref(false);
let emailErrorMessage = ref("");
let phoneErrorMessage = ref("");
let isSuperAdmin = ref(false);
let isLoggedInUser = ref(false);
let selectedSites = ref([]);
let isSelectAllSites = ref(false);

const validEmail = () => {
  isEmailLoading.value = false;
  emailErrorMessage.value = null;
  isPhoneLoading.value = false;
  isValidEmail.value = checkEmailValidation(email.value);
  if (isValidEmail.value) {
    checkDuplicateField("email", email.value);
  } else {
    emailErrorMessage.value = "Invalid Email.";
  }
};

// const validPhone = () => {
//   isPhoneLoading.value = true;
//   phoneErrorMessage.value = null;
//   isValidPhone.value = true;
//   if(phone.value){
//     checkDuplicateField('phone', phone.value);
//   }
// }

const checkDuplicateField = (field, value) => {
  if (field == "email") {
    isEmailLoading.value = true;
    isValidEmail.value = true;
  }
  // else if(field == 'phone'){
  //   isPhoneLoading.value = true;
  // }

  usersStore
    .checkDuplicateField({
      companyId: companyId,
      params: {
        id: id.value,
        field: field,
        value: value,
        country_code: field == "phone" ? country_code.value : null,
      },
    })
    .then((res) => {
      if (field == "email") {
        isEmailLoading.value = false;
        if (!res.data) {
          emailErrorMessage.value =
            "Email address already exists, register with a different one.";
          isValidEmail.value = false;
        } else {
          isValidEmail.value = true;
        }
      }
      // else if(field == 'phone'){
      //   isPhoneLoading.value = false;
      //   if(!res.data){
      //     phoneErrorMessage.value = 'Phone already exists, register with a different one.';
      //     isValidPhone.value = false;
      //   }else{
      //     isValidPhone.value = true;
      //   }
      // }
    })
    .catch(() => {
    });
};

const changeCountryCode = (country) => {
  country_code.value = country.dialCode;
  // if(phone.value && country.dialCode != intial_country_code.value) validPhone();
};

const changeUserRole = () => {
  //  showSitesSecttion.value = true;
  if (role.value.name == "Owner") {
    sites.value = [];
    showSitesSecttion.value = false;
  }
};

const onSelectAllSitesChange = (event) => {
  selectedSites.value = event.checked
    ? props.sitesOptions.map((item) => item.id)
    : [];

  isSelectAllSites.value = event.checked;
};

const onChangeSitesVal = (event) => {
  selectedSites.value = event.value;
  if (selectedSites.value.length === props.sitesOptions.length) {
    isSelectAllSites.value = true;
  } else if (selectedSites.value.length < props.sitesOptions.length) {
    isSelectAllSites.value = false;
  }
};

const getSiteName = (id) => {
  const found = props.sitesOptions.find((s) => s.id === id);
  return found ? found.name : id;
};

const removeSite = (siteId) => {
  selectedSites.value = selectedSites.value.filter((id) => id !== siteId);
};

const onSubmit = async () => {
  isSubmitted.value = true;
  await selectedSites.value.map(async (id) => {
    let newObj = {};
    newObj.type = "site";
    newObj.value = id;
    resources.value.push(newObj);
  });

  const data = {
    id: id.value,
    first_name: first_name.value,
    last_name: last_name.value,
    email: email.value,
    phone: phone.value,
    country_code: phone.value ? country_code.value : null,
    role_id: role.value,
    resources: resources.value,
    companyId,
  };
  usersStore
    .editUser(data)
    .then(() => {
      emit("refresh");
      resetStoreData();
    })
    .catch(() => {
    });
};

const resetStoreData = () => {
  uiStore.resetModalStore();
};

onBeforeMount(() => {
  if (
    uiStore.modalData &&
    uiStore.modalData.first_name &&
    uiStore.modalAction == "edit_user"
  ) {
    id.value = uiStore.modalData.id;
    first_name.value = uiStore.modalData.first_name;
    last_name.value = uiStore.modalData.last_name;
    email.value = uiStore.modalData.email;
    phone.value = uiStore.modalData.phone;
    country_code.value = uiStore.modalData.country_code
      ? parseInt(uiStore.modalData.country_code.replace(/\+/g, ""))
      : null;
    intial_country_code.value = uiStore.modalData.country_code
      ? parseInt(uiStore.modalData.country_code.replace(/\+/g, ""))
      : null;
    role.value = uiStore.modalData.role.id;

    if (user.value.user_id == uiStore.modalData.id) {
      isLoggedInUser.value = true;
    }

    if (uiStore.modalData.role.name == "owner") {
      isSuperAdmin.value = true;
      showSitesSecttion.value = false;
    }

    uiStore.modalData.sites.map(async (obj) => {
      selectedSites.value.push(obj.id);
    });
  }
});
</script>
<template>
  <DModal :visible="uiStore.modalAction === 'edit_user'" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]" :dialog_classes="[]">
    <template #title> Edit User </template>

    <template #body>
      <div class="mb-3">
        <DInput
          :value="first_name"
          @input="first_name = $event.target.value"
          type="text"
          label="First Name"
          width="100%"
        />
      </div>

      <div class="mb-3">
        <DInput
          :value="last_name"
          @input="last_name = $event.target.value"
          type="text"
          label="Last Name"
          width="100%"
        />
      </div>

      <div class="mb-3">
        <DInput
          :value="email"
          @input="(e) => { email = e.target.value; validEmail(); }"
          type="email"
          label="Email Address"
          width="100%"
          :isLoading="isEmailLoading"
          :errMsg="emailErrorMessage"
        />
      </div>

      <div class="form-phone mb-3">
        <div class="phone-label flex items-center">
          Phone Number (Optional)
        </div>
        <vue-tel-input
          v-model="phone"
          :defaultCountry="country_code"
          @country-changed="changeCountryCode"
          placeholder="Phone Number (Optional)"
          type="text"
          :class="{ 'is-invalid': !isValidPhone }"
          class="form-control"
          id="phoneNumber"
        ></vue-tel-input>
        <!-- <input v-model="phone" @input="validPhone" type="text" :class="{'is-invalid' : !isValidPhone}" class="form-control" id="phoneNumber" placeholder="Phone Number" /> -->
        <!-- <label for="phoneNumber">Phone Number (Optional)</label> -->
        <span
          v-if="isPhoneLoading"
          class="spinner-sm text-success float-right inputSpinner"
          role="status"
          aria-hidden="true"
        ></span>
        <div
          v-if="!isValidPhone"
          class="invalid-feedback"
          v-text="phoneErrorMessage"
        ></div>
      </div>

      <div v-if="!isSuperAdmin">
        <!-- <div class="relative mb-3">
          <span v-if="role" class="multiselect-title-span">Role</span>
          <VMultiselect
            @select="changeUserRole"
            v-model="role"
            :options="props.rolesOptions"
            :disabled="!props.rolesOptions.length || isLoggedInUser"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            placeholder="Role"
            trackBy="id"
            label="label"
          />
        </div> -->

        <FloatLabel class="w-full md:w-14rem mb-3">
          <PDropdown
            v-model="role"
            inputId="role"
            :options="props.rolesOptions"
            :disabled="!props.rolesOptions.length || isLoggedInUser"
            placeholder="Role"
            optionLabel="label"
            optionValue="id"
            class="w-full"
            @change="changeUserRole"
            filter
            filterPlaceholder="Search by role name"
          />
          <label for="role">Role</label>
        </FloatLabel>

        <!-- <div class="relative mb-3">
          <span v-if="sites.length" class="multiselect-title-span">Stores</span>
          <VMultiselect
            :class="{ 'multiselect-options': sites.length }"
            v-model="sites"
            :options="props.sitesOptions"
            :disabled="!props.sitesOptions.length || isLoggedInUser"
            :multiple="true"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            placeholder="Stores"
            trackBy="id"
            label="name"
          />
        </div> -->

        <FloatLabel
          v-if="showSitesSecttion"
          class="w-full md:w-80 mb-3"
          variant="in"
        >
          <PMultiSelect
            v-model="selectedSites"
            :options="props.sitesOptions"
            :selectAll="isSelectAllSites"
            :disabled="!props.sitesOptions.length || isLoggedInUser"
            optionLabel="name"
            optionValue="id"
            @selectall-change="onSelectAllSitesChange($event)"
            @change="onChangeSitesVal($event)"
            :virtualScrollerOptions="{ itemSize: 30 }"
            filter
            class="custom-multiselect"
            panelClass="custom-multiselect-panel"
            display="chip"
            id="sitesOptions"
            :maxSelectedLabels="2"
            filterPlaceholder="Search by site name"
          >
            <template #value="slotProps">
              <div
                v-if="slotProps.value && slotProps.value.length"
                class="flex items-center"
              >
                <div v-if="slotProps.value.length > 2">
                  {{ slotProps.value.length }} items selected
                </div>
                <div v-else class="flex">
                  <div
                    v-for="id in slotProps.value"
                    :key="id"
                    class="p-multiselect-token"
                  >
                    <span class="p-multiselect-token-label">{{
                      getSiteName(id)
                    }}</span>
                    <span
                      class="p-multiselect-token-icon"
                      @click.stop="removeSite(id)"
                    >
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="p-icon"
                      >
                        <path
                          d="M10.5 3.5L3.5 10.5"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M3.5 3.5L10.5 10.5"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                  </div>
                </div>
              </div>
              <span v-else>
                {{ slotProps.placeholder }}
              </span>
            </template>
          </PMultiSelect>
          <label for="storesOptions">Sites</label>
        </FloatLabel>
      </div>
    </template>

    <template #footer>
      <div class="w-full">
        <div class="seperator text-center"></div>
        <div class="flex mt-20 justify-center">
          <button
            :disabled="
              !first_name ||
              !last_name ||
              !email ||
              !role ||
              (!selectedSites.length && showSitesSecttion) ||
              !isValidEmail ||
              !isValidPhone ||
              isSubmitted
            "
            @click="onSubmit"
            type="button"
            class="btn btn-primary add-button mr-30"
          >
            Edit
            <span
              v-if="isSubmitted"
              class="spinner-sm"
              role="status"
              aria-hidden="true"
            ></span>
          </button>
          <button
            @click="resetStoreData"
            type="button"
            class="btn btn-secondary cancel-button"

          >
            Cancel
          </button>
        </div>
      </div>
    </template>
  </DModal>
</template>
